import React from 'react'
import {Row, Col, Container } from 'react-bootstrap'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
   <footer className='footer-section'>
    <img src={require('../assets/images/fb.jpg')} className="footer-bg-img" />
    <div className='footer-content'>
      <Container fluid>
     <Row>
        <Col lg={4} md={4}>
         <div className='footer-box-1'>
            <div className='footer-logo'>
              <img src={require('../assets/images/f-logo.png')} alt="f-logo" />
            </div>
            <p>Apprenticeshipale is a company that specializes in providing high-quality apprenticeship opportunities to people looking to learn new skills and start a career in a particular industry.</p>
         </div>
        </Col>
        <Col lg={4} md={4}>
          <div className='footer-menu f-box'>
            <h4 className='footer-heading'>EXPLORE</h4>
            <ul>
              <li><Link to='/'>Home</Link></li>
              <li><Link to='/about'>About</Link></li>
              {/* <li><a href='#'>Services</a></li> */}
              <li><Link to='/job-listing'>Opportunities</Link></li>
              <li><Link to='/contact'>Contact Us</Link></li>
              {/* <li><a href='#'>Terms of use</a></li> */}
              {/* <li><a href='#'>Privacy Policy</a></li> */}
              {/* <li><a href='#'>Legal</a></li> */}
              {/* <li><a href='#'>Sitemap</a></li> */}
            </ul>
          </div>
        </Col>
        <Col lg={4} md={4}>
          <div className='address-box f-box'>
          <h4 className='footer-heading'>Contact</h4>
          <ul>
            <li>Office No.105, 1st Floor, Nawada Printing Press,</li>
            <li>Village Naharpur (Kasan), Post Nakhrola,</li>
            <li>Opposite Donaldson India Filters, Gurgaon  - 122004,</li>
            <li>Haryana, India</li>
          </ul>
          <a href="mailto:support@apprenticeshipwale.com">support@apprenticeshipwale.com</a>
          </div>
        </Col>
     </Row>
     </Container>
     <div className='footer-bottom-text'>
        <p>Consortium partners - Vaishnavi Integrated Services & Jan Aadhar Society </p>

     </div>
     <div className='footer-bottom'>
       <Container fluid>
       <Row>
          <Col md={6}>
           <p className='paragraph-1'>© 2023 Apprenticeshipwale.com  All Rights Reserved.</p>
          </Col>
          <Col md={6}>
          <p className='paragraph-2'>Site created by RAJMITH</p>
          </Col>
       </Row>
       </Container>
     </div>
    </div>
   </footer>
  )
}
